import { LOCALE } from '@/legacy-src/constants/locale.constants'

// Whether an address includes a county is resolved per LOCALE.
export const getAddressIncludesCounty = () => LOCALE === 'ro'
